import React from "react";

export function Skeleton({ className = "" }: { className?: string }) {
  return (
    <div
      className={`animate-pulse bg-muted ${className}`}
      style={{ minHeight: 24, borderRadius: 8 }}
    />
  );
} 